import { authApi } from './api'

/**
 * Sets up window.NerdCRM bridge for native mobile wrapper apps.
 * The mobile app can call these methods after obtaining FCM/APNs tokens.
 */
export function setupDeviceTokenBridge() {
  window.NerdCRM = {
    async registerDeviceToken(token: string, platform: 'ios' | 'android') {
      await authApi.registerDeviceToken({ token, platform })
    },

    async removeDeviceToken(token: string) {
      await authApi.removeDeviceToken(token)
    },
  }
}
